import reactLogo from '../img/60icontec.png'

export const ReactLogo = () => {
    return (
        <img src={reactLogo}
            alt="React Logo"
            style={{
                position: 'fixed',
                bottom: '10px',
                right: '50px',
                width: '130px'
            }}
        />
    )
}